var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOkchainBc = function SvgOkchainBc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1756_70329",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 94,
    height: 94
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H94V94H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1756_70329)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8888 7H8.77774C7.79593 7 7 7.79593 7 8.77774V31.8888C7 32.8707 7.79593 33.6667 8.77774 33.6667H31.8888C32.8707 33.6667 33.6667 32.8707 33.6667 31.8888V8.77774C33.6667 7.79593 32.8707 7 31.8888 7ZM58.567 33.6667H35.456C34.474 33.6667 33.6781 34.4626 33.6781 35.4444V58.5555C33.6781 59.5373 34.474 60.3332 35.456 60.3332H58.567C59.5488 60.3332 60.3448 59.5373 60.3448 58.5555V35.4444C60.3448 34.4626 59.5488 33.6667 58.567 33.6667ZM62.1112 7H85.2223C86.2041 7 87 7.79593 87 8.77774V31.8888C87 32.8707 86.2041 33.6667 85.2223 33.6667H62.1112C61.1293 33.6667 60.3333 32.8707 60.3333 31.8888V8.77774C60.3333 7.79593 61.1293 7 62.1112 7ZM31.8888 60.3333H8.77774C7.79593 60.3333 7 61.1293 7 62.1112V85.2223C7 86.2041 7.79593 87 8.77774 87H31.8888C32.8707 87 33.6667 86.2041 33.6667 85.2223V62.1112C33.6667 61.1293 32.8707 60.3333 31.8888 60.3333ZM62.1112 60.3333H85.2223C86.2041 60.3333 87 61.1293 87 62.1112V85.2223C87 86.2041 86.2041 87 85.2223 87H62.1112C61.1293 87 60.3333 86.2041 60.3333 85.2223V62.1112C60.3333 61.1293 61.1293 60.3333 62.1112 60.3333Z",
    fill: "white",
    fillOpacity: 0.2
  }))));
};

export { SvgOkchainBc as ReactComponent };
export default __webpack_public_path__ + "3e6e42f70ad5216f2f6bf7f932ec7491.svg";